import { DateSelectionDetail } from '../shared/date-picker/date-picker.model';

export class ViewStateModel {
  current?: string;
  dashboardList?: ViewModel;
  cockpit?: ViewModel;
  dataSourcesList?: ViewModel;
  destinationQuality?: ViewModel;
  statistics?: ViewModel;
  webNavigation?: ViewModel;
  facebook?: ViewModel;
  reportList?: ViewModel;
  mountainDestinations?: ViewModel;
  cbdbe?: ViewModel;
  eventCompass?: ViewModel;
  statfeed?: ViewModel;
  municipalityReport?: ViewModel;
  statisticsCockpit?: ViewModel;
}

export class ViewModel {
  title?: string;
  tabs?: {
    enabled?: boolean;
    tabList?: string[] | number[];
    selected?: number;
  };
  showMunicipality?: boolean;
  showToolSidebar?: boolean;
  dateSelection?: DateSelectionDetail;
  filterSelection?:
    | any
    | {
        attribute: string;
        value: string;
      };
}

export class SetCurrentView {
  static readonly type = '[View] SetCurrentView';
  constructor(public currentView: string) {}
}

export class SetView {
  static readonly type = '[View] SetView';
  constructor(
    public payload: { viewSelection: string; viewState: ViewModel }
  ) {}
}

export class ResetView {
  static readonly type = '[View] ResetView';
  constructor() {}
}
